// import prod02img01 from "../../Images/Products/prod02img01.jpg";
// import prod02img02 from "../../Images/Products/prod02img02.jpg";
// import prod02img03 from "../../Images/Products/prod02img03.jpg";
// import prod02img04 from "../../Images/Products/prod02img04.jpg";
// import prod05img01 from "../../Images/Products/prod05img01.jpg";
// import prod06img01 from "../../Images/Products/prod06img01.jpg";
// import prod06img02 from "../../Images/Products/prod06img02.jpg";
// import prod06img03 from "../../Images/Products/prod06img03.jpg";
// import prod07img01 from "../../Images/Products/prod07img01.jpg";
// import prod08img01 from "../../Images/Products/prod08img01.jpg";
// import prod17img01 from "../../Images/Products/prod17img01.jpg";
// import prod17img02 from "../../Images/Products/prod17img02.jpg";
// import prod17img03 from "../../Images/Products/prod17img03.jpg";

// FLOR DE MAR
import adr1076 from "../../Images/Products/ADR_1076.jpg";
import adr1069 from "../../Images/Products/ADR_1069.jpg";
import adr1071 from "../../Images/Products/ADR_1071.jpg";
import adr1074 from "../../Images/Products/ADR_1074.jpg";
import adr1075 from "../../Images/Products/ADR_1075.jpg";

// 1147
import adr1147 from "../../Images/Products/ADR_1147.jpg";
import adr1144 from "../../Images/Products/ADR_1144.jpg";
import adr1149 from "../../Images/Products/ADR_1149.jpg";
import adr1152 from "../../Images/Products/ADR_1152.jpg";
import adr1153 from "../../Images/Products/ADR_1153.jpg";
import adr1155 from "../../Images/Products/ADR_1155.jpg";
import adr1156 from "../../Images/Products/ADR_1156.jpg";
import adr1158 from "../../Images/Products/ADR_1158.jpg";

// 1193
import adr1193 from "../../Images/Products/ADR_1193.jpg";
import adr1160 from "../../Images/Products/ADR_1160.jpg";
import adr1161 from "../../Images/Products/ADR_1161.jpg";
import adr1163 from "../../Images/Products/ADR_1163.jpg";
import adr1166 from "../../Images/Products/ADR_1166.jpg";
import adr1168 from "../../Images/Products/ADR_1168.jpg";
import adr1175 from "../../Images/Products/ADR_1175.jpg";
import adr1182 from "../../Images/Products/ADR_1182.jpg";
import adr1189 from "../../Images/Products/ADR_1189.jpg";
import adr1191 from "../../Images/Products/ADR_1191.jpg";

// 1197
import adr1197 from "../../Images/Products/ADR_1197.jpg";
import adr1196 from "../../Images/Products/ADR_1196.jpg";
import adr1198 from "../../Images/Products/ADR_1198.jpg";
import adr1200 from "../../Images/Products/ADR_1200.jpg";
import adr1202 from "../../Images/Products/ADR_1202.jpg";
import adr1206 from "../../Images/Products/ADR_1206.jpg";

// EVERGLADES
import adr1134 from "../../Images/Products/ADR_1134.jpg";
import adr1138 from "../../Images/Products/ADR_1138.jpg";
import adr1120 from "../../Images/Products/ADR_1120.jpg";
import adr1112 from "../../Images/Products/ADR_1112.jpg";
import adr1114 from "../../Images/Products/ADR_1114.jpg";
import adr1119 from "../../Images/Products/ADR_1119.jpg";
import adr1128 from "../../Images/Products/ADR_1128.jpg";
import adr1133 from "../../Images/Products/ADR_1133.jpg";
import adr1142 from "../../Images/Products/ADR_1142.jpg";

// 1106
import adr1106 from "../../Images/Products/ADR_1106.jpg";
import adr1110 from "../../Images/Products/ADR_1106.jpg";
import adr1108 from "../../Images/Products/ADR_1106.jpg";
import adr1104 from "../../Images/Products/ADR_1106.jpg";

// 1095
import adr1095 from "../../Images/Products/ADR_1095.jpg";
import adr1096 from "../../Images/Products/ADR_1096.jpg";
import adr1099 from "../../Images/Products/ADR_1099.jpg";
import adr1102 from "../../Images/Products/ADR_1102.jpg";

// WALL ART
import adr1084 from "../../Images/Products/ADR_1084.jpg";
import adr1089 from "../../Images/Products/ADR_1089.jpg";
import adr1094 from "../../Images/Products/ADR_1094.jpg";

// MOON
import prod09img01 from "../../Images/Products/prod09img01.jpg";
import prod09img02 from "../../Images/Products/prod09img02.jpg";
import prod09img03 from "../../Images/Products/prod09img03.jpg";
import prod09img04 from "../../Images/Products/prod09img04.jpg";

// STARGATE
import prod01img01 from "../../Images/Products/prod01img01.jpg";
import prod01img02 from "../../Images/Products/prod01img02.jpg";
import prod01img03 from "../../Images/Products/prod01img03.jpg";
import prod01img04 from "../../Images/Products/prod01img04.jpg";
import prod01img05 from "../../Images/Products/prod01img05.jpg";

// EROSION
import prod03img01 from "../../Images/Products/prod03img01.jpg";
import prod03img02 from "../../Images/Products/prod03img02.jpg";
import prod03img03 from "../../Images/Products/prod03img03.jpg";
import prod03img04 from "../../Images/Products/prod03img04.jpg";

// SHAI HULUD
import prod04img01 from "../../Images/Products/prod04img01.jpg";
import prod04img02 from "../../Images/Products/prod04img02.jpg";
import prod04img03 from "../../Images/Products/prod04img03.jpg";

// SHAI HULUD (natural)
import prod12img01 from "../../Images/Products/prod12img01.jpg";
import prod12img02 from "../../Images/Products/prod12img02.jpg";
import prod12img03 from "../../Images/Products/prod12img03.jpg";

// SINAPSIS
import prod10img01 from "../../Images/Products/prod10img01.jpg";
import prod10img02 from "../../Images/Products/prod10img02.jpg";
import prod10img03 from "../../Images/Products/prod10img03.jpg";
import prod10img04 from "../../Images/Products/prod10img04.jpg";
import prod10img05 from "../../Images/Products/prod10img05.jpg";

// VIDRIAGON
import prod11img01 from "../../Images/Products/prod11img01.jpg";
import prod11img02 from "../../Images/Products/prod11img02.jpg";
import prod11img03 from "../../Images/Products/prod11img03.jpg";
import prod11img04 from "../../Images/Products/prod11img04.jpg";

// WALL ART NRO 2
// import prod14img01 from "../../Images/Products/prod14img01.jpg";
// import prod14img02 from "../../Images/Products/prod14img02.jpg";
// import prod14img03 from "../../Images/Products/prod14img03.jpg";
// import prod14img04 from "../../Images/Products/prod14img04.jpg";
// import prod14img05 from "../../Images/Products/prod14img05.jpg";

// FRANCA
import prod16img01 from "../../Images/Products/prod16img01.jpg";
import prod16img02 from "../../Images/Products/prod16img02.jpg";
import prod16img03 from "../../Images/Products/prod16img03.jpg";

// AFRICAN STARGATE
import prod15img01 from "../../Images/Products/prod15img01.jpg";
import prod15img02 from "../../Images/Products/prod15img02.jpg";
import prod15img03 from "../../Images/Products/prod15img03.jpg";

// EIFFEL
import prod13img01 from "../../Images/Products/prod13img01.jpg";
import prod13img02 from "../../Images/Products/prod13img02.jpg";
import prod13img03 from "../../Images/Products/prod13img03.jpg";
import prod13img04 from "../../Images/Products/prod13img04.jpg";

// FLAMIGERA
// import prod18img01 from "../../Images/Products/prod18img01.jpg";
// import prod18img02 from "../../Images/Products/prod18img02.jpg";
// import prod18img03 from "../../Images/Products/prod18img03.jpg";
// import prod18img04 from "../../Images/Products/prod18img04.jpg";

export const products = [
  {
    name: "Flor de Mar",
    size: "45cm / 50cms",
    images: [adr1076, adr1069, adr1071, adr1074, adr1075],
    format: "h",
  },
  {
    name: "Flame",
    size: "43 x 66cm",
    images: [adr1147, adr1144, adr1149, adr1152, adr1153, adr1155, adr1156, adr1158],
    format: "v",
  },
  {
    name: "Roots",
    size: "85 x 70 x 66cm",
    images: [adr1193, adr1160, adr1161, adr1163, adr1166, adr1168, adr1175, adr1182, adr1189, adr1191],
    format: "v",
  },
  {
    name: "Nahla",
    size: "69 x 23cm",
    images: [adr1197, adr1196, adr1198, adr1200, adr1202, adr1206],
    format: "h",
  },
  {
    name: "Everglades",
    size: "43cm",
    images: [adr1134, adr1138, adr1120, adr1112, adr1114, adr1119, adr1128, adr1133, adr1142],
    format: "h",
  },
  { name: "Mediopico", size: "60 x 22cm", images: [adr1106, adr1110, adr1108, adr1104], format: "v" },
  { name: "Guenoa", size: "43 x 18cm", images: [adr1095, adr1096, adr1099, adr1102], format: "v" },
  { name: "Wall Art", size: "47 x 48cm", images: [adr1084, adr1089, adr1094], format: "h" },
  {
    name: "Erosión",
    size: "56cm",
    images: [prod03img01, prod03img02, prod03img03, prod03img04],
    format: "h",
  },
  {
    name: "Moon",
    size: "51cm",
    images: [prod09img01, prod09img02, prod09img03, prod09img04],
    format: "v",
  },
  {
    name: "Stargate",
    size: "58cm",
    images: [prod01img02, prod01img01, prod01img03, prod01img04, prod01img05],
    format: "v",
  },
  // { name: "Wall Art", size: "48 x 50cms", images: [prod02img01, prod02img02, prod02img03, prod02img04] },
  {
    name: "Shai-Hulud",
    size: "52cm",
    images: [prod04img01, prod04img02, prod04img03],
    format: "h"
  },
  {
    name: "Shai-Hulud (natural)",
    size: "52cm",
    images: [prod12img01, prod12img02, prod12img03],
    format: "v"
  },
  // { name: "Flor de Mar", size: "56 x 60cms", images: [prod06img01, prod06img02, prod06img03] },
  // { name: "Flor de Mar", size: "56 x 60cms", images: [prod07img01] },
  // { name: "Flor de Mar", size: "56 x 60cms", images: [prod08img01] },
  {
    name: "Sinapsis",
    size: "49cm / 50cm",
    images: [prod10img01, prod10img02, prod10img03, prod10img04, prod10img05],
    format: "v"
  },
  {
    name: "Vidriagón",
    size: "48 x 23 cm",
    images: [prod11img01, prod11img02, prod11img03, prod11img04],
    format: "v"
  },
  // {
  //   name: "Wall Art Nro2",
  //   size: "-",
  //   images: [prod14img01, prod14img02, prod14img03, prod14img04, prod14img05],
  // },
  {
    name: "Franca",
    size: "180 x 48 cm",
    images: [prod16img01, prod16img02, prod16img03],
    format: "v"
  },
  {
    name: "African Stargate",
    size: "56cm",
    images: [prod15img01, prod15img02, prod15img03],
    format: "v"
  },
  // { name: "Everglades", size: "-", images: [prod17img01, prod17img02, prod17img03] },
  {
    name: "Eiffel",
    size: "160 x 45 cm",
    images: [prod13img01, prod13img02, prod13img03, prod13img04],
    format: "v"
  },
  // {
  //   name: "Flamígera",
  //   size: "-",
  //   images: [prod18img01, prod18img02, prod18img03, prod18img04],
  // },
];
